import React, { useEffect, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import { connect } from "react-redux";
import api from "../../CommonApi/axios";
import { setLanguage, setBranchId, setCustome, getCustomData } from "../../Store";
import { Dropdown } from "react-bootstrap";

import "./Lun.css"
import { useIsMobile } from "../../Customer/CommonComponet/MediaQueries/mediaQueries";
import CookieManagementComponent from "../../Customer/CommonComponet/Cookie/Cookie";

function LanguageSelect(props) {
  const { setLanguage, language, setBranchId, branchId, customRes } = props;

  // console.log("customRes", customRes);

  const isMobile = useIsMobile();
  var pathname = window.location.href;
  var pathnamesplits = pathname
    .replace(/(https?:\/\/)?(www.)?/i, "")
    .split("/");
  var urlBranchID = String(pathnamesplits[1]);
  // const { tableId } = useParams();

  // useEffect(() => {
  //   getCartList();
  // }, [props.BranchID]);

  useEffect(() => {
    setLanguage("en");
  }, [props.BranchID]);

  const [BranchLanguageData, setBranchLanguageData] = useState([]);

  const onSelect = (code) => {
    setLanguage(
      code === "US"
        ? "en"
        : code === "FR"
          ? "fr"
          : code === "DE"
            ? "de"
            : code == "IT"
              ? "it"
              : "AR"
    );
  };

  // console.log("props", props.language);

  // function getCartList() {
  //   if (urlBranchID != undefined && urlBranchID != "") {
  //     if (props.BranchID) (
  //       api.get(`/client/order/branchDetails/${props.BranchID}`).then((res) => {
  //         const tableData = res.data.data?.resData?.languange;
  //         setLanguage(
  //           res?.data?.data?.resData?.primary_language === "English"
  //             ? "en"
  //             : res?.data?.data?.resData?.primary_language === "français"
  //               ? "fr"
  //               : res?.data?.data?.resData?.primary_language === "Deutsch"
  //                 ? "de"
  //                 : res?.data?.data?.resData?.primary_language === "Italiano"
  //                   ? "it"
  //                   : res?.data?.data?.resData?.primary_language === "arabic"
  //                     ? "AE"
  //                     : "en"
  //         );
  //         let arr = [];
  //         if (tableData != undefined && tableData) {
  //           for (let index = 0; index < tableData.length; index++) {
  //             const element = tableData[index];
  //             if (element.includes("English")) {
  //               arr.push("US");
  //             }
  //             if (element.includes("français")) {
  //               arr.push("FR");
  //             }
  //             if (element.includes("Deutsch")) {
  //               arr.push("DE");
  //             }
  //             if (element.includes("Italiano")) {
  //               arr.push("IT");
  //             }
  //             if (element.includes("arabic")) {
  //               arr.push("AE");
  //             }
  //           }
  //         }
  //         setBranchLanguageData(arr);
  //       })
  //     )
  //   }
  // }



  const [selectedLanguage, setSelectedLanguage] = useState(null);

  // const handleLanguageSelect = (language, code) => {
  //   setSelectedLanguage(language);
  //   console.log(language ,code);
  //   // return

  //   localStorage.setItem('LanguageStorageImage', language?.image);
  //   localStorage.setItem('LanguageStorageCode', language?.code);

  //   window.location.hash = `googtrans(en|${code?.toLowerCase()})`;
  //   window.location.reload(true);
  // };

  const handleLanguageSelect = (language, code) => {
    setSelectedLanguage(language);
    // console.log(language, code);

    let transformedCode = code;
    if (code.length > 2) {
      transformedCode = code?.slice(0, 2)?.toLowerCase() + code?.slice(2)?.toUpperCase();
    }

    localStorage.setItem('LanguageStorageImage', language?.image);
    localStorage.setItem('LanguageStorageCode', transformedCode);

    window.location.hash = `googtrans(en|${transformedCode})`;
    window.location.reload(true);
  };


  const LanguageStorageImage = localStorage.getItem('LanguageStorageImage');
  const LanguageStorageCode = localStorage.getItem('LanguageStorageCode');

  // console.log("LanguageStorageCode", LanguageStorageCode)

  useEffect(() => {
    if (LanguageStorageImage && LanguageStorageCode) {
      if (LanguageStorageCode.length > 2) {
        window.location.hash = `googtrans(en|${LanguageStorageCode?.slice(0, 2)?.toLowerCase() + LanguageStorageCode?.slice(2).toUpperCase()})`;
      }else{
        window.location.hash = `googtrans(en|${LanguageStorageCode?.toLowerCase()})`;
      }
    } else {
      window.location.hash = `googtrans(en|en)`;
    }
  }, [LanguageStorageImage && LanguageStorageCode])


  // console.log("storedLanguage" , LanguageStorageImage ,LanguageStorageCode);

  // useEffect(() => {
  //   if (customRes && customRes.lang && customRes.lang.length > 0) {
  //     setSelectedLanguage(customRes.lang[0]); // Set the first language as the default selected language
  //     window.location.hash = `googtrans(en|en)`;
  //   }
  // }, [customRes]);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <React.Fragment>
      <Dropdown drop="down-centered" className={isMobile ? "me-0" : "me-2"}>
        <Dropdown.Toggle variant="success"
          style={{
            color: customRes?.menu_text_colour || "black",
            background: "transparent",
            border: 0
          }}>
          <React.Fragment>
            {LanguageStorageImage ? (
              <React.Fragment>
                <img loading="lazy" src={LanguageStorageImage} alt={LanguageStorageImage} className="me-2"
                  style={{ width: "43px", height: "32px" }} />
                {/* <span className="notranslate" style={{ fontWeight: 600 }}>{LanguageStorageCode}</span> */}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <svg
                  width={43}
                  height={32}
                  viewBox="0 0 64 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1660_938)">
                    <rect width={64} height={48} fill="white" />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 0H64V48H0V0Z"
                      fill="#F7FCFF"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 29.3333V33.3333H64V29.3333H0Z"
                      fill="#E31D1C"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 36.6667V40.6667H64V36.6667H0Z"
                      fill="#E31D1C"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 14.6667V18.6667H64V14.6667H0Z"
                      fill="#E31D1C"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 44V48H64V44H0Z"
                      fill="#E31D1C"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 22V26H64V22H0Z"
                      fill="#E31D1C"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 0V4H64V0H0Z"
                      fill="#E31D1C"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 7.33325V11.3333H64V7.33325H0Z"
                      fill="#E31D1C"
                    />
                    <rect width={40} height={26} fill="#2E42A5" />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.44393 5.87741L1.99217 6.89519L2.4823 5.08397L1.19287 3.93614H2.87705L3.4419 2.45801L4.10425 3.93614H5.53996L4.41189 5.08397L4.84861 6.89519L3.44393 5.87741ZM11.4439 5.87741L9.99217 6.89519L10.4823 5.08397L9.19287 3.93614H10.877L11.4419 2.45801L12.1042 3.93614H13.54L12.4119 5.08397L12.8486 6.89519L11.4439 5.87741ZM17.9922 6.89519L19.4439 5.87741L20.8486 6.89519L20.4119 5.08397L21.54 3.93614H20.1042L19.4419 2.45801L18.877 3.93614H17.1929L18.4823 5.08397L17.9922 6.89519ZM27.4439 5.87741L25.9922 6.89519L26.4823 5.08397L25.1929 3.93614H26.877L27.4419 2.45801L28.1042 3.93614H29.54L28.4119 5.08397L28.8486 6.89519L27.4439 5.87741ZM1.99217 14.8952L3.44393 13.8774L4.84861 14.8952L4.41189 13.084L5.53996 11.9361H4.10425L3.4419 10.458L2.87705 11.9361H1.19287L2.4823 13.084L1.99217 14.8952ZM11.4439 13.8774L9.99217 14.8952L10.4823 13.084L9.19287 11.9361H10.877L11.4419 10.458L12.1042 11.9361H13.54L12.4119 13.084L12.8486 14.8952L11.4439 13.8774ZM17.9922 14.8952L19.4439 13.8774L20.8486 14.8952L20.4119 13.084L21.54 11.9361H20.1042L19.4419 10.458L18.877 11.9361H17.1929L18.4823 13.084L17.9922 14.8952ZM27.4439 13.8774L25.9922 14.8952L26.4823 13.084L25.1929 11.9361H26.877L27.4419 10.458L28.1042 11.9361H29.54L28.4119 13.084L28.8486 14.8952L27.4439 13.8774ZM1.99217 22.8952L3.44393 21.8774L4.84861 22.8952L4.41189 21.084L5.53996 19.9361H4.10425L3.4419 18.458L2.87705 19.9361H1.19287L2.4823 21.084L1.99217 22.8952ZM11.4439 21.8774L9.99217 22.8952L10.4823 21.084L9.19287 19.9361H10.877L11.4419 18.458L12.1042 19.9361H13.54L12.4119 21.084L12.8486 22.8952L11.4439 21.8774ZM17.9922 22.8952L19.4439 21.8774L20.8486 22.8952L20.4119 21.084L21.54 19.9361H20.1042L19.4419 18.458L18.877 19.9361H17.1929L18.4823 21.084L17.9922 22.8952ZM27.4439 21.8774L25.9922 22.8952L26.4823 21.084L25.1929 19.9361H26.877L27.4419 18.458L28.1042 19.9361H29.54L28.4119 21.084L28.8486 22.8952L27.4439 21.8774ZM33.9922 6.89519L35.4439 5.87741L36.8486 6.89519L36.4119 5.08397L37.54 3.93614H36.1042L35.4419 2.45801L34.877 3.93614H33.1929L34.4823 5.08397L33.9922 6.89519ZM35.4439 13.8774L33.9922 14.8952L34.4823 13.084L33.1929 11.9361H34.877L35.4419 10.458L36.1042 11.9361H37.54L36.4119 13.084L36.8486 14.8952L35.4439 13.8774ZM33.9922 22.8952L35.4439 21.8774L36.8486 22.8952L36.4119 21.084L37.54 19.9361H36.1042L35.4419 18.458L34.877 19.9361H33.1929L34.4823 21.084L33.9922 22.8952ZM7.44393 9.87741L5.99217 10.8952L6.4823 9.08397L5.19287 7.93614H6.87705L7.4419 6.45801L8.10425 7.93614H9.53996L8.41189 9.08397L8.84861 10.8952L7.44393 9.87741ZM13.9922 10.8952L15.4439 9.87741L16.8486 10.8952L16.4119 9.08397L17.54 7.93614H16.1042L15.4419 6.45801L14.877 7.93614H13.1929L14.4823 9.08397L13.9922 10.8952ZM23.4439 9.87741L21.9922 10.8952L22.4823 9.08397L21.1929 7.93614H22.877L23.4419 6.45801L24.1042 7.93614H25.54L24.4119 9.08397L24.8486 10.8952L23.4439 9.87741ZM5.99217 18.8952L7.44393 17.8774L8.84861 18.8952L8.41189 17.084L9.53996 15.9361H8.10425L7.4419 14.458L6.87705 15.9361H5.19287L6.4823 17.084L5.99217 18.8952ZM15.4439 17.8774L13.9922 18.8952L14.4823 17.084L13.1929 15.9361H14.877L15.4419 14.458L16.1042 15.9361H17.54L16.4119 17.084L16.8486 18.8952L15.4439 17.8774ZM21.9922 18.8952L23.4439 17.8774L24.8486 18.8952L24.4119 17.084L25.54 15.9361H24.1042L23.4419 14.458L22.877 15.9361H21.1929L22.4823 17.084L21.9922 18.8952ZM31.4439 9.87741L29.9922 10.8952L30.4823 9.08397L29.1929 7.93614H30.877L31.4419 6.45801L32.1042 7.93614H33.54L32.4119 9.08397L32.8486 10.8952L31.4439 9.87741ZM29.9922 18.8952L31.4439 17.8774L32.8486 18.8952L32.4119 17.084L33.54 15.9361H32.1042L31.4419 14.458L30.877 15.9361H29.1929L30.4823 17.084L29.9922 18.8952Z"
                      fill="#F7FCFF"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1660_938">
                      <rect width={64} height={48} fill="white" />
                    </clipPath>
                  </defs>
                </svg>

              </React.Fragment>
            )}
          </React.Fragment>
        </Dropdown.Toggle>
        <Dropdown.Menu className="menu__">
          {customRes?.lang?.length > 0 && customRes?.lang?.map((language, index) => (
            <Dropdown.Item key={index} onClick={() => handleLanguageSelect(language, language.code)}>
              <img loading="lazy" src={language.image} alt={language.name}
                className="me-3" style={{ width: "35px", height: "27px" }} />
              <span className="notranslate">{language.code} </span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
      <CookieManagementComponent customRes={customRes} />
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  language: state.branch.language,
  branchId: state.branch.branchId,

  customRes: state.custom.customRes,
  customUrl: state.custom.customUrl,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLanguage: (language) => dispatch(setLanguage(language)),
    setBranchId: (id) => dispatch(setBranchId(id)),
    setCustome: (url) => dispatch(setCustome(url)),
    getCustomData: () => dispatch(getCustomData()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelect);
